module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/sec_problem_img03-8399d42c707d5ac6bc969c4da0397a6a.svg";